const floatingLabelContainer = "relative w-full";

const fullWidth = "w-full";

const label = "mb-1 block text-sm font-medium text-foreground/70 transition-colors duration-200";

const inputWithIconFloating = "pl-9 py-2.5";

const relative = "relative";

export { floatingLabelContainer, fullWidth, label, inputWithIconFloating, relative };
